import * as React from 'react';
import styled from 'styled-components';

const Picture = styled.img`
  width: 100%;
  border-radius: 50%;
  background-color: black;
`;

const NameText = styled.p`
  margin-top: 18px;
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: normal;
  text-align: center;

  color: #00144d;

  span {
    color: rgba(0, 20, 77, 0.6);
  }

  margin-bottom: 0px !important;
`;

const ProfilePictureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface ProfilePictureProps {
  profImg: string;
  profName: string;
}

const ProfilePicture = ({ profImg, profName }: ProfilePictureProps) => {
  return (
    <ProfilePictureContainer>
      <Picture src={profImg} />
      <NameText>
        {profName}
        <br />
        <span>SEAS '21</span>
      </NameText>
    </ProfilePictureContainer>
  );
};

export default ProfilePicture;



// WEBPACK FOOTER //
// ./src/pages/AboutUs/components/ProfilePicture.tsx